import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import { GetReRegistrationList } from "../../services/ReRegistrationService";
import { setReRegistrations } from "../../store/actions";
import ReRegistrationList from "./ReRegistrationList";
import { ContentWrapper } from "../common/GlobalElements/Wrappers";
import { Heading3 } from "../common/GlobalElements/Typography";

function ReRegistration(props) {
  const isMounted = useRef(true);
  const [reRegistrationList, SetReRegistrationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    isMounted.current = true;
    setLoading(true)
    GetReRegistrationList().then((res) => {
      if (isMounted.current) {
        SetReRegistrationList(res.data);
        dispatch(setReRegistrations(res.data))
        setLoading(false);
      }
    })
      .catch((error) => {
        console.log("error", error)
        setLoading(false)
      });
    return () => {
      isMounted.current = false;
    }

  }, [props.id]);



  return (
    <>
      <div className="re-registration-list-wrap page-content-x-padding">
        <Heading3 className="landing-heading mb-4">
          My <span>Applications</span>
        </Heading3>

        {loading
          ? <SkeletonContainer height={getSkeletonHeight(14)} />
          : <>
            <ul className="card-grid re-registration-ul-list list-unstyled">
              {/* only show the tabs which has show key equal to 1 in open array */}
              {reRegistrationList && reRegistrationList.open ? (
                props.id !== undefined
                  ? reRegistrationList.open.filter(item => item.id === Number(props.id))?.filter(item => item?.show == 1).map((registration, index) => {
                    return <ReRegistrationList registration={registration} key={index} />;
                  })
                  : reRegistrationList.open?.filter(item => item?.show == 1).map((registration, index) => {
                    return <ReRegistrationList registration={registration} key={index} />;
                  })
              ) : (
                <SkeletonContainer height={getSkeletonHeight(13)} />
              )}
            </ul>

            {/* Show Completed */}
            {reRegistrationList?.close?.length > 0 ? (
              <>
                <button
                  data-toggle="collapse"
                  data-target="#completed-exam"
                  aria-expanded="false"
                  className="collapsed hide-completed"
                ></button>
                <div
                  className="re-registration-completed-list collapse"
                  id="completed-exam"
                >
                  <ul className="card-grid re-registration-ul-list list-unstyled">
                    {/* {card should be not clickable if the registration is closed not registered}****************************** disabled prop is for this pur only********* */}
                    {reRegistrationList.close.filter(item => item?.show == 1).map((registration, index) => {
                      return <ReRegistrationList registration={registration} disabled={!(registration.registrationStatus || registration.per)} key={index} />;
                    })
                    }
                  </ul>
                </div>
              </>
            ) : null}
          </>
        }

      </div>
    </>
  );
}

export default ReRegistration;
